import { RESET_STATE } from '../auth/constants';
import { ACTIVE_SEASON_ALERT_SET_IGNORE } from './constants';
import { ActiveSeasonAlertState, ActiveSeasonAlertActions } from './types';

const initialState: ActiveSeasonAlertState = {
    ignore: false
};

export default function (
    state: ActiveSeasonAlertState = initialState,
    action: ActiveSeasonAlertActions
): ActiveSeasonAlertState {
    switch (action.type) {
        case ACTIVE_SEASON_ALERT_SET_IGNORE:
            return {
                ignore: action.payload
            };
        case RESET_STATE:
            return initialState;
        default:
            return state;
    }
}
